/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charge/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Charge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/Charges/Charge"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let chargeNameValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'name',
format: fromHelpers.getChargeName,
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let chargeAmountValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'amount',
format: fromFormat.numberMoney,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Charge.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2nG5Pd': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--ml-2-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-2nG5Pd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 flexGrow={1}
 flexShrink={1}
 flexBasis={0}
 data="charge.name"
 format="helpers.js getChargeName"
 text={chargeNameValueData}
 color={dtColorsBlack}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.amount"
 format="/Data/format.js numberMoney"
 text={chargeAmountValueData}
 weight="medium"
 color={dtColorsBlack}
 marginLeft={dtSpaceS}
/>
</div>
{children}
</React.Fragment>)
}